import tripoolSwapABI from './json/3pool/swap';
import tricryptoSwap from './json/tricrypto-harmony/swap';
import tricryptoZap from './json/tricrypto-harmony/zap';

const multicall_address = '0x3E01dD8a5E1fb3481F0F589056b428Fc308AF0Fb';

const poolsData = {
    '3pool': {
        swap_abi: tripoolSwapABI,
        N_COINS: 3,
        coin_precisions: [1e18, 1e6, 1e6],
        wrapped_precisions: [1e18, 1e6, 1e6],
        tethered: [false, false, false],
        use_lending: [false, false, false],
        is_plain: [true, true, true],
        swap_address: '0xC5cfaDA84E902aD92DD40194f0883ad49639b023',
        token_address: '0xC5cfaDA84E902aD92DD40194f0883ad49639b023',
        gauge_address: '0xbF7E49483881C76487b0989CD7d9A8239B20CA41',
        underlying_coins: [
            '0xEf977d2f931C1978Db5F6747666fa1eACB0d0339',
            '0x985458E523dB3d53125813eD68c274899e9DfAb4',
            '0x3C2B8Be99c50593081EAA2A724F0B8285F5aba8f',
        ],
        coins: [
            '0xEf977d2f931C1978Db5F6747666fa1eACB0d0339',
            '0x985458E523dB3d53125813eD68c274899e9DfAb4',
            '0x3C2B8Be99c50593081EAA2A724F0B8285F5aba8f',
        ],
    },
    atricrypto: {
        swap_abi: tricryptoSwap,
        deposit_abi: tricryptoZap,
        N_COINS: 5,
        REAL_COINS: 3, //cause this is a fake plain pool
        coin_precisions: [1e18, 1e6, 1e6, 1e8, 1e18],
        wrapped_precisions: [1e18, 1e8, 1e18],
        real_precisions: [1e18, 1e8, 1e18],
        tethered: [false, false, false, false, false],
        use_lending: [false, false, false, false, false],
        is_plain: [true, true, true, true, true],
        swap_address: '0x0e3Dc2BcbFEa84072A0c794B7653d3db364154e0',
        token_address: '0x99E8eD28B97c7F1878776eD94fFC77CABFB9B726',
        gauge_address: '0xF98450B5602fa59CC66e1379DFfB6FDDc724CfC4',
        deposit_address: '0x76147c0C989670D106b57763a24410A2a22e335E',
        pool_type: 'crypto',
        base_pool: '3pool',
        underlying_coins: [
          '0xEf977d2f931C1978Db5F6747666fa1eACB0d0339', //DAI
          '0x985458E523dB3d53125813eD68c274899e9DfAb4', // USDC
          '0x3c2b8be99c50593081eaa2a724f0b8285f5aba8f', //usdt
          '0x3095c7557bcb296ccc6e363de01b760ba031f2d9', //WBTC
          '0x6983d1e6def3690c4d616b13597a09e6193ea013', //WETH
        ],
        coins: [
          '0xEf977d2f931C1978Db5F6747666fa1eACB0d0339', //DAI
          '0x985458E523dB3d53125813eD68c274899e9DfAb4', // USDC
          '0x3c2b8be99c50593081eaa2a724f0b8285f5aba8f', //usdt
          '0x3095c7557bcb296ccc6e363de01b760ba031f2d9', //WBTC
          '0x6983d1e6def3690c4d616b13597a09e6193ea013', //WETH
        ],
    },
};

export {
    multicall_address,
    poolsData,
};
